<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="ticket_list_header">
        <div class="d_flex_btwn">
          <div class="d_flex_start">
            <router-link
              :to="{ name: 'tickets' }"
              class="btn btn_black mr_10 d_flex_center has_border_radius"
              >Back to List</router-link
            >

            <button
              type="button"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
              @click.prevent="openReplyBox('reply')"
            >
              <span class="mr_5 d_flex_center">
                <svg
                  fill="#000000"
                  width="18px"
                  height="18px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M10.53 5.03a.75.75 0 10-1.06-1.06l-6.25 6.25a.75.75 0 000 1.06l6.25 6.25a.75.75 0 101.06-1.06L5.56 11.5H17a3.248 3.248 0 013.25 3.248v4.502a.75.75 0 001.5 0v-4.502A4.748 4.748 0 0017 10H5.56l4.97-4.97z"
                    ></path>
                  </g>
                </svg>
              </span>
              <span>Reply</span>
            </button>

            <button
              type="button"
              v-if="ticket.status == 'open' || ticket.status == 'pending'"
              @click.prevent="changeTicketStatus('resolved')"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
            >
              <span class="mr_5 d_flex_center">
                <svg
                  width="18px"
                  height="18px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 32 32"
                  enable-background="new 0 0 32 32"
                  xml:space="preserve"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <polyline
                      fill="none"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      points="28,8 16,20 11,15 "
                    ></polyline>
                    <path
                      d="M26.7,13.5c0.2,0.8,0.3,1.6,0.3,2.5c0,6.1-4.9,11-11,11S5,22.1,5,16S9.9,5,16,5c3,0,5.7,1.2,7.6,3.1l1.4-1.4 C22.7,4.4,19.5,3,16,3C8.8,3,3,8.8,3,16s5.8,13,13,13s13-5.8,13-13c0-1.4-0.2-2.8-0.7-4.1L26.7,13.5z"
                    ></path>
                  </g>
                </svg>
              </span>
              <span>Mark as resolved</span>
            </button>

            <button
              type="button"
              v-if="ticket.status != 'closed'"
              @click.prevent="changeTicketStatus('closed')"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
            >
              <span class="mr_5 d_flex_center">
                <svg
                  width="18px"
                  height="18px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 32 32"
                  enable-background="new 0 0 32 32"
                  xml:space="preserve"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <polyline
                      fill="none"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      points="28,8 16,20 11,15 "
                    ></polyline>
                    <path
                      d="M26.7,13.5c0.2,0.8,0.3,1.6,0.3,2.5c0,6.1-4.9,11-11,11S5,22.1,5,16S9.9,5,16,5c3,0,5.7,1.2,7.6,3.1l1.4-1.4 C22.7,4.4,19.5,3,16,3C8.8,3,3,8.8,3,16s5.8,13,13,13s13-5.8,13-13c0-1.4-0.2-2.8-0.7-4.1L26.7,13.5z"
                    ></path>
                  </g>
                </svg>
              </span>
              <span>Close</span>
            </button>

            <button
              type="button"
              @click.prevent="deleteRecord(ticket.id)"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
            >
              <span class="mr_5 d_flex_center">
                <svg
                  width="18px"
                  height="18px"
                  viewBox="0 -0.5 21 21"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <title>delete [#1487]</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Dribbble-Light-Preview"
                        transform="translate(-179.000000, -360.000000)"
                        fill="#000000"
                      >
                        <g
                          id="icons"
                          transform="translate(56.000000, 160.000000)"
                        >
                          <path
                            d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                            id="delete-[#1487]"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <span>Delete</span>
            </button>
          </div>

          <div class="d_flex_center">
            <a
              type="button"
              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
              @click="showTicketActivity"
            >
              <span class="mr_5 d_flex_center">
                <i class="lni lni-alarm-clock"></i>
              </span>
              <span v-if="isShowTicketActivityLog">Hide activities</span>
              <span v-else>Show activities</span>
            </a>
            <div class="retail_pagination p_0 mr_10">
              <ul>
                <li v-if="ticket.previous_ticket_id">
                  <router-link :to="`/ticket/${ticket.previous_ticket_id}`">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 19.5 8.25 12l7.5-7.5"
                      ></path>
                    </svg>
                  </router-link>
                </li>
                <li v-if="ticket.next_ticket_id">
                  <router-link :to="`/ticket/${ticket.next_ticket_id}`">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                      ></path>
                    </svg>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="collapse_contact">
              <button
                class="btn btn_transparent has_border_radius p_5"
                @click="hideShowCollapseContact"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 32 32"
                  class="app-icon app-icon--small icon-detail-right"
                >
                  <path
                    d="M20.038 4.29H4.895a.606.606 0 00-.606.606v22.21c0 .335.271.606.606.606h15.143V4.291zm2.423 0v23.421h4.644a.606.606 0 00.606-.606V4.895a.606.606 0 00-.606-.606h-4.644zM4.895 1.867h22.21a3.029 3.029 0 013.029 3.029v22.21a3.029 3.029 0 01-3.029 3.029H4.895a3.029 3.029 0 01-3.029-3.029V4.896a3.029 3.029 0 013.029-3.029zM13.479 16l-4.191-4.191a1.211 1.211 0 011.713-1.713l5.048 5.048c.473.473.473 1.24 0 1.713l-5.048 5.048a1.211 1.211 0 01-1.713-1.713l4.191-4.191z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="vlan_ticket_list_details_page">
        <div
          class="vlan_ticket_list_page_wrap vlan_ticket_list_all_wrap"
          :class="{
            collapse_contact_open: !isHideCollapseContact,
            no_right_filter: isHideCollapseContact,
          }"
        >
          <div class="vlan_ticket_list_left">
            <div class="vlan_ticket_list_left_wrap">
              <div
                class="vlan_ticket_list_table_wrap vlan_ticket_list_details_table_wrap"
              >
                <div class="mail_box_details_head">
                  <div class="d_flex_btwn">
                    <div class="d_flex_start">
                      <h2>
                        <span class="fw_500 mr_10"
                          >Ticket #: {{ ticket.ticket_number }},
                          {{ ticket.subject }}</span
                        >
                        <button type="button" class="btn btn_sm btn_black">
                          {{ ticket.status }}
                        </button>
                      </h2>
                    </div>
                  </div>
                </div>
                <div
                  ref="targetSection"
                  id="targetSection"
                  class="ticket_mail_box_details"
                >
                  <template v-if="isShowTicketActivityLog">
                    <TicketActivityLogs />
                  </template>
                  <template v-else>
                    <div class="mail_details_content">
                      <div class="mail_box_head_wrap">
                        <div class="left">
                          <div class="author">
                            <img :src="ticket?.contact?.photo" alt="" />
                          </div>
                          <div class="content_details">
                            <p>
                              <b>{{ ticket.customer_name }}</b>
                              <span v-if="ticket.request_from"
                                >Reported via {{ ticket.request_from }}</span
                              >
                            </p>
                            <p>
                              {{ ticket.formatted_created_at }} ({{
                                ticket.created_at
                              }})
                            </p>
                            <p>
                              <b class="fw_500">To:</b
                              ><span class="mr_10">help@vlan24.com</span>
                              <template v-if="ticket.cc_email">
                                <b class="fw_500">Cc:</b
                                ><span>{{ ticket.cc_email }}</span>
                              </template>
                              <template v-if="ticket.bcc_email">
                                <b class="fw_500 ml_5">Bcc:</b
                                ><span>{{ ticket.bcc_email }}</span>
                              </template>
                            </p>
                          </div>
                        </div>
                        <div class="right">
                          <ul>
                            <li
                              class="cursor_pointer"
                              title="Edit"
                              @click.prevent="openSidebar(ticket, 'email')"
                            >
                              <span
                                ><svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path
                                      d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                      stroke="#000000"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M21 21H12"
                                      stroke="#000000"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </g></svg
                              ></span>
                            </li>
                            <li
                              @click.prevent="
                                openReplyBox('forward', ticket.description)
                              "
                              class="cursor_pointer"
                              title="Forward"
                            >
                              <span>
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path
                                      d="M4 17V15.8C4 14.1198 4 13.2798 4.32698 12.638C4.6146 12.0735 5.07354 11.6146 5.63803 11.327C6.27976 11 7.11984 11 8.8 11H20M20 11L16 7M20 11L16 15"
                                      stroke="#000000"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </g>
                                </svg>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="ticket_email_body"
                        v-html="ticket.description"
                      ></div>
                      <attachment-preview-component
                        v-if="ticket?.attachments"
                        :attachments="ticket.attachments"
                      />

                      <attachment-preview-component
                        v-if="ticket?.parent_mail?.attachments"
                        :attachments="ticket.parent_mail.attachments"
                      />
                    </div>
                    <template
                      v-for="(email, emailIndex) in ticket.emails"
                      :key="'singleMail_' + emailIndex"
                    >
                      <div class="reply_mail_content mt_15">
                        <ul>
                          <li>
                            <div class="reply_box_head_wrap">
                              <div class="left">
                                <div class="author">
                                  <template
                                    v-if="
                                      email.email_creator_user_type == 'admin'
                                    "
                                  >
                                    <img
                                      :src="
                                        email.email_created_by_admin
                                          ? email.email_created_by_admin
                                              .profile_image
                                          : ''
                                      "
                                      alt=""
                                    />
                                  </template>
                                  <template
                                    v-if="
                                      email.email_creator_user_type == 'user'
                                    "
                                  >
                                    <img
                                      :src="
                                        email.email_created_by_customer
                                          ? email.email_created_by_customer
                                              .profile_image
                                          : ''
                                      "
                                      alt=""
                                    />
                                  </template>
                                </div>
                                <div class="content_details">
                                  <p>
                                    <b
                                      v-if="
                                        email.email_creator_user_type == 'admin'
                                      "
                                    >
                                      {{
                                        email.email_created_by_admin
                                          ? email.email_created_by_admin.name
                                          : ''
                                      }}
                                    </b>
                                    <b
                                      v-if="
                                        email.email_creator_user_type == 'user'
                                      "
                                    >
                                      {{
                                        email.email_created_by_customer
                                          ? email.email_created_by_customer.name
                                          : ''
                                      }}
                                    </b>
                                    {{
                                      getEmailType(
                                        email.email_type,
                                        email.note_mode
                                      )
                                    }}
                                  </p>
                                  <p>
                                    {{ email.formatted_created_at }} ({{
                                      email.created_at
                                    }})
                                  </p>
                                  <p>
                                    <template
                                      v-if="email.email_type == 'reply'"
                                    >
                                      <b class="fw_500">To:</b
                                      ><span class="mr_10">
                                        {{ email.to_email }}</span
                                      >
                                    </template>
                                    <template v-if="email.forward_to_emails">
                                      <b class="fw_500">Forwarded to:</b
                                      ><span class="mr_5">
                                        {{ email.forward_to_emails }}</span
                                      >
                                    </template>
                                    <template v-if="email.cc_emails">
                                      <b class="fw_500">Cc:</b
                                      ><span>{{ email.cc_emails }}</span>
                                    </template>
                                    <template v-if="email.bcc_emails">
                                      <b class="fw_500 ml_5">Bcc:</b
                                      ><span>{{ email.bcc_emails }}</span>
                                    </template>
                                    <template v-if="email.notify_emails">
                                      <b class="fw_500">Notified to:</b
                                      ><span>{{ email.notify_emails }}</span>
                                    </template>
                                  </p>
                                </div>
                              </div>
                              <div class="right">
                                <ul>
                                  <template v-if="email.email_type == 'note'">
                                    <li
                                      v-if="email.note_mode == 'public'"
                                      @click.prevent="
                                        openReplyBox(
                                          'forward',
                                          email.description
                                        )
                                      "
                                      class="cursor_pointer"
                                      title="Forward"
                                    >
                                      <span
                                        ><svg
                                          width="18px"
                                          height="18px"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g
                                            id="SVGRepo_bgCarrier"
                                            stroke-width="0"
                                          ></g>
                                          <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></g>
                                          <g id="SVGRepo_iconCarrier">
                                            <path
                                              d="M4 17V15.8C4 14.1198 4 13.2798 4.32698 12.638C4.6146 12.0735 5.07354 11.6146 5.63803 11.327C6.27976 11 7.11984 11 8.8 11H20M20 11L16 7M20 11L16 15"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </li>
                                    <li
                                      class="cursor_pointer"
                                      title="Edit"
                                      @click.prevent="
                                        openSidebar(email, 'note')
                                      "
                                    >
                                      <span
                                        ><svg
                                          width="18px"
                                          height="18px"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g
                                            id="SVGRepo_bgCarrier"
                                            stroke-width="0"
                                          ></g>
                                          <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></g>
                                          <g id="SVGRepo_iconCarrier">
                                            <path
                                              d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                              stroke="#000000"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                            <path
                                              d="M21 21H12"
                                              stroke="#000000"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </li>
                                    <li
                                      class="cursor_pointer"
                                      title="Delete"
                                      @click.prevent="deleteNote(email.id)"
                                    >
                                      <span>
                                        <svg
                                          width="18px"
                                          height="18px"
                                          viewBox="0 -0.5 21 21"
                                          version="1.1"
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlns:xlink="http://www.w3.org/1999/xlink"
                                          fill="#000000"
                                        >
                                          <g
                                            id="SVGRepo_bgCarrier"
                                            stroke-width="0"
                                          ></g>
                                          <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></g>
                                          <g id="SVGRepo_iconCarrier">
                                            <title>delete [#1487]</title>
                                            <desc>Created with Sketch.</desc>
                                            <defs></defs>
                                            <g
                                              id="Page-1"
                                              stroke="none"
                                              stroke-width="1"
                                              fill="none"
                                              fill-rule="evenodd"
                                            >
                                              <g
                                                id="Dribbble-Light-Preview"
                                                transform="translate(-179.000000, -360.000000)"
                                                fill="#000000"
                                              >
                                                <g
                                                  id="icons"
                                                  transform="translate(56.000000, 160.000000)"
                                                >
                                                  <path
                                                    d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                                                    id="delete-[#1487]"
                                                  ></path>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </svg>
                                      </span>
                                    </li>
                                  </template>
                                  <template v-else>
                                    <li
                                      @click.prevent="
                                        openReplyBox(
                                          'forward',
                                          email.description
                                        )
                                      "
                                      class="cursor_pointer"
                                      title="Forward"
                                    >
                                      <span
                                        ><svg
                                          width="18px"
                                          height="18px"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g
                                            id="SVGRepo_bgCarrier"
                                            stroke-width="0"
                                          ></g>
                                          <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></g>
                                          <g id="SVGRepo_iconCarrier">
                                            <path
                                              d="M4 17V15.8C4 14.1198 4 13.2798 4.32698 12.638C4.6146 12.0735 5.07354 11.6146 5.63803 11.327C6.27976 11 7.11984 11 8.8 11H20M20 11L16 7M20 11L16 15"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                          </g></svg
                                      ></span>
                                    </li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                            <div class="mail_reply_details_content">
                              <div
                                class="ticket_email_body"
                                v-html="email.description"
                              ></div>
                            </div>
                            <attachment-preview-component
                              v-if="email.attachments"
                              :attachments="email.attachments"
                            />
                          </li>
                        </ul>
                      </div>
                    </template>
                  </template>

                  <ReplyBoxComponent
                    v-if="showReplyBox"
                    :showReplyBox="showReplyBox"
                    :replyBoxType="replyBoxType"
                    :ticket="ticket"
                    :forwardedMessage="forwarded_message"
                    @closeReplyBox="closeReplyBox"
                  />
                </div>
              </div>
              <div class="bottom_fixed_content">
                <div class="d_flex_start pt_5 pb_5">
                  <div class="avatar info_bg">
                    <span>{{ userFirstLetter() }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn btn_transparent has_border_radius mr_10 d_flex_center ticket_mail_reply_button"
                    @click.prevent="openReplyBox('reply')"
                  >
                    <span class="mr_5 d_flex_center">
                      <svg
                        fill="#000000"
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M10.53 5.03a.75.75 0 10-1.06-1.06l-6.25 6.25a.75.75 0 000 1.06l6.25 6.25a.75.75 0 101.06-1.06L5.56 11.5H17a3.248 3.248 0 013.25 3.248v4.502a.75.75 0 001.5 0v-4.502A4.748 4.748 0 0017 10H5.56l4.97-4.97z"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <span>Reply</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn_transparent has_border_radius mr_10 d_flex_center"
                    @click.prevent="openReplyBox('note')"
                  >
                    <span class="mr_5 d_flex_center">
                      <svg
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M13 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V9M13 3L19 9M13 3V8C13 8.55228 13.4477 9 14 9H19M9 13H15M9 17H15"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <span>Add Notes</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn_transparent has_border_radius mr_10 d_flex_center"
                    @click.prevent="openReplyBox('forward')"
                  >
                    <span class="mr_5 d_flex_center">
                      <svg
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M4 17V15.8C4 14.1198 4 13.2798 4.32698 12.638C4.6146 12.0735 5.07354 11.6146 5.63803 11.327C6.27976 11 7.11984 11 8.8 11H20M20 11L16 7M20 11L16 15"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <span>Forward</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="vlan_ticket_list_right">
            <div class="ticket_list_filter">
              <h2 class="ticket_list_title">
                <span class="fw_500"
                  >Current status : {{ ticket.status }}
                </span>
                <div v-if="ticket.resolution_status">
                  <button
                    v-if="ticket.resolution_status == 'Overdue'"
                    type="button"
                    class="btn btn_sm btn_danger"
                  >
                    {{ ticket.resolution_status }}
                  </button>
                  <button v-else type="button" class="btn btn_sm btn_info">
                    {{ ticket.resolution_status }}
                  </button>
                </div>
                <div
                  class="fw_regular font_14p pt_5 pb_5"
                  v-if="ticket.status == 'closed'"
                >
                  {{ ticket.formatted_created_at }}
                </div>
              </h2>

              <div class="ticket_list_filter_inner">
                <div class="form_row">
                  <label> Created date</label>
                  <div class="form_input">
                    {{ ticket.created_at }}
                  </div>
                </div>

                <div class="form_row" v-if="ticket.resolution_at">
                  <label> Resolution date</label>
                  <div class="form_input">
                    {{ ticket.resolution_at_formatted }}
                  </div>
                </div>

                <div class="form_row" v-if="ticket.closed_at">
                  <label> Closed date</label>
                  <div class="form_input">
                    {{ ticket.closed_at_formatted }}
                  </div>
                </div>

                <div class="form_row" v-if="ticket.resolved_at">
                  <label> Resolved date</label>
                  <div class="form_input">
                    {{ ticket.resolved_at_formatted }}
                  </div>
                </div>
                <div
                  :class="[
                    'form_row',
                    { has_error: errorFor('resolution_at') },
                  ]"
                >
                  <label class=""> Resolution date</label>
                  <div class="form_input">
                    <date-picker
                      v-model:input="filter.resolution_at"
                    ></date-picker>
                  </div>
                  <v-errors :errors="errorFor('resolution_at')"></v-errors>
                </div>
                <div :class="['form_row', { has_error: errorFor('group_id') }]">
                  <label class=""> Request Type</label>
                  <Multiselect
                    v-model="filter.support_request_type_id"
                    :options="requestTypes"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a request type"
                    :custom-label="requestTypeLabel"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onRequestTypeSelect"
                    @remove="onRequestTypeRemove"
                    :disabled="user?.user_role !== 'Admin'"
                  />
                  <v-errors :errors="errorFor('group_id')"></v-errors>
                </div>
                <div :class="['form_row', { has_error: errorFor('group_id') }]">
                  <label class=""> Group</label>
                  <Multiselect
                    v-model="filter.group_id"
                    :options="groups"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a group"
                    :custom-label="groupLabel"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onGroupSelect"
                    @remove="onGroupRemove"
                    :disabled="user?.user_role !== 'Admin'"
                  />
                  <v-errors :errors="errorFor('group_id')"></v-errors>
                </div>
                <div :class="['form_row', { has_error: errorFor('user_ids') }]">
                  <label class=""> User </label>
                  <Multiselect
                    v-model="filter.users"
                    :options="users"
                    :multiple="true"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a user"
                    :custom-label="userLabel"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onUserSelect"
                    @remove="onUserRemove"
                    :disabled="user?.user_role !== 'Admin'"
                  />
                  <v-errors :errors="errorFor('user_ids')"></v-errors>
                </div>
                <div :class="['form_row', { has_error: errorFor('status') }]">
                  <label class="required"> Status Include </label>
                  <Multiselect
                    v-model="filter.status"
                    :options="statuses"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a status"
                    :custom-label="statusLabel"
                    track-by="label"
                    :optionHeight="20"
                    @Select="onStatusSelect"
                    @remove="onStatusRemove"
                  />
                  <v-errors :errors="errorFor('status')"></v-errors>
                </div>
                <div :class="['form_row', { has_error: errorFor('priority') }]">
                  <label class=""> Priority Include </label>
                  <Multiselect
                    v-model="filter.priority"
                    :options="priorities"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a priority"
                    :custom-label="priorityLabel"
                    track-by="label"
                    :optionHeight="20"
                    @Select="onPrioritySelect"
                    @remove="onPriorityRemove"
                  />
                  <v-errors :errors="errorFor('priority')"></v-errors>
                </div>
                <div
                  :class="['form_row', { has_error: errorFor('contact_id') }]"
                >
                  <label>Contact Email</label>
                  <Multiselect
                    v-model="filterContact"
                    :options="contacts"
                    :multiple="false"
                    :close-on-select="true"
                    placeholder="Select a contact"
                    label="name"
                    :optionHeight="20"
                    track-by="id"
                    :custom-label="nameWithEmail"
                  />
                  <v-errors :errors="errorFor('contact_id')"></v-errors>
                </div>
                <div
                  :class="[
                    'form_row',
                    { has_error: errorFor('customer_phone') },
                  ]"
                >
                  <label>Contact phone</label>
                  <div class="form_inline">
                    <input
                      type="text"
                      class="form_global"
                      v-model="filter.customer_phone"
                    />
                    <v-errors :errors="errorFor('customer_phone')"></v-errors>
                  </div>
                </div>
                <div
                  :class="['form_row', { has_error: errorFor('company_id') }]"
                >
                  <label class=""> Company</label>
                  <Multiselect
                    v-model="filter.company_id"
                    :options="companies"
                    :multiple="false"
                    :showLabels="false"
                    :close-on-select="true"
                    placeholder="Select a company"
                    :custom-label="companyLabel"
                    track-by="id"
                    :optionHeight="20"
                    @Select="onCompanySelect"
                    @remove="onCompanyRemove"
                  />
                  <v-errors :errors="errorFor('company_id')"></v-errors>
                </div>
              </div>
              <button
                v-if="ticket.status != 'closed'"
                type="button"
                class="btn btn_black has_border_radius"
                @click.prevent="updateTicketDetails()"
              >
                Update
              </button>
            </div>
          </div>
          <div class="vlan_ticket_list_all_right">
            <div class="vlan_ticket_list_all_filter">
              <div class="vlan_ticket_list_all_filter_inner">
                <div class="accordion_wrap">
                  <div class="accordion">
                    <div class="accordion_heading">
                      <div
                        class="accordion_heading_inner open"
                        data-toggle="collapse_slide"
                        data-target="#cCard2"
                      >
                        <span
                          ><svg
                            width="15px"
                            height="15px"
                            viewBox="0 0 24 24"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            fill="#000000"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
                              <title>
                                ic_fluent_contact_card_group_24_regular
                              </title>
                              <desc>Created with Sketch.</desc>
                              <g
                                id="🔍-Product-Icons"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="ic_fluent_contact_card_group_24_regular"
                                  fill="#212121"
                                  fill-rule="nonzero"
                                >
                                  <path
                                    d="M18.75,4 C20.5449254,4 22,5.45507456 22,7.25 L22,16.754591 C22,18.5495164 20.5449254,20.004591 18.75,20.004591 L5.25,20.004591 C3.45507456,20.004591 2,18.5495164 2,16.754591 L2,7.25 C2,5.51696854 3.35645477,4.10075407 5.06557609,4.00514479 L5.25,4 L18.75,4 Z M18.75,5.5 L5.25,5.5 L5.10647279,5.5058012 C4.20711027,5.57880766 3.5,6.3318266 3.5,7.25 L3.5,16.754591 C3.5,17.7210893 4.28350169,18.504591 5.25,18.504591 L18.75,18.504591 C19.7164983,18.504591 20.5,17.7210893 20.5,16.754591 L20.5,7.25 C20.5,6.28350169 19.7164983,5.5 18.75,5.5 Z M9.25257038,12.5 C9.66678394,12.5 10.0025704,12.8357864 10.0025704,13.25 L10.0025704,13.8321918 C10.0025704,15.1041956 9.0341,15.75 7.50128519,15.75 C5.96840664,15.75 5,15.1036013 5,13.8310402 L5,13.25 C5,12.8357864 5.33578644,12.5 5.75,12.5 L9.25257038,12.5 Z M10.8334902,12.4985863 L12.25,12.5 C12.6642136,12.5 13,12.8357864 13,13.25 L13,13.582681 C13,14.5462268 12.2350063,15 11.125,15 C11.0088628,15 10.8965027,14.9950281 10.7884008,14.9850208 C10.9003752,14.7160989 10.9702591,14.4160784 10.9937337,14.0856775 L11.0025704,13.8321918 L11.0025704,13.25 C11.0025704,12.9810441 10.9418968,12.7262593 10.8334902,12.4985863 Z M15.2496688,12.5 L18.25,12.5 C18.6642136,12.5 19,12.8357864 19,13.25 C19,13.6296958 18.7178461,13.943491 18.3517706,13.9931534 L18.25,14 L15.2496688,14 C14.8354552,14 14.4996688,13.6642136 14.4996688,13.25 C14.4996688,12.8703042 14.7818227,12.556509 15.1478982,12.5068466 L15.2496688,12.5 L18.25,12.5 L15.2496688,12.5 Z M7.50071279,8.5 C8.32953357,8.5 9.00142557,9.171892 9.00142557,10.0007128 C9.00142557,10.8295336 8.32953357,11.5014256 7.50071279,11.5014256 C6.671892,11.5014256 6,10.8295336 6,10.0007128 C6,9.171892 6.671892,8.5 7.50071279,8.5 Z M11.3699891,9.00225167 C12.0591015,9.00225167 12.6177374,9.56088763 12.6177374,10.25 C12.6177374,10.9391124 12.0591015,11.4977483 11.3699891,11.4977483 C10.6808767,11.4977483 10.1222408,10.9391124 10.1222408,10.25 C10.1222408,9.56088763 10.6808767,9.00225167 11.3699891,9.00225167 Z M15.2496688,9.5 L18.25,9.5 C18.6642136,9.5 19,9.83578644 19,10.25 C19,10.6296958 18.7178461,10.943491 18.3517706,10.9931534 L18.25,11 L15.2496688,11 C14.8354552,11 14.4996688,10.6642136 14.4996688,10.25 C14.4996688,9.87030423 14.7818227,9.55650904 15.1478982,9.50684662 L15.2496688,9.5 L18.25,9.5 L15.2496688,9.5 Z"
                                    id="🎨-Color"
                                  ></path>
                                </g>
                              </g>
                            </g></svg
                        ></span>
                        <span>Contact Details</span>
                      </div>
                    </div>
                    <div
                      class="accordion_body"
                      id="cCard2"
                      style="display: block"
                    >
                      <div class="t_c_contact_wrap">
                        <template v-if="ticket.contact">
                          <div class="inner mb_20">
                            <div class="inner_wrap">
                              <router-link
                                :to="`/contact/${ticket.contact_id}/show`"
                              >
                                <div class="contact_name">
                                  <div class="avatar info_bg">
                                    <span>{{
                                      ticket?.contact?.name?.charAt(0)
                                    }}</span>
                                  </div>
                                  <div class="text">
                                    <p>{{ ticket.contact.name }}</p>
                                    <p>{{ ticket.contact.title }}</p>
                                  </div>
                                </div>
                              </router-link>
                            </div>
                          </div>
                          <div class="form_row">
                            <label> Email</label>
                            <div class="form_input">
                              {{ ticket.contact.email }}
                            </div>
                          </div>
                          <div class="d_flex_start pt_5 pb_20">
                            <router-link
                              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
                              :to="`/contact/${ticket.contact_id}/show`"
                              >View More Info</router-link
                            >
                          </div>
                          <h3>Timeline</h3>
                          <div class="ticket_timeline">
                            <ul>
                              <li
                                v-for="(latest_ticket, index) in ticket.contact
                                  .latest_tickets"
                                :key="'latest_ticket_' + index"
                              >
                                <router-link
                                  :to="`/ticket/${latest_ticket.ticket_number}`"
                                >
                                  <div class="box">
                                    <span></span>
                                    <div class="title">
                                      {{ latest_ticket.subject }}
                                    </div>
                                    <div class="info">
                                      <span class="mr_5">{{
                                        latest_ticket.ticket_number
                                      }}</span>
                                    </div>
                                    <div class="info">
                                      <span class="mr_5"
                                        ><span
                                          >Status:
                                          {{ latest_ticket.status }}</span
                                        ></span
                                      >
                                    </div>
                                    <div class="time">
                                      <span>{{
                                        latest_ticket.created_at
                                      }}</span>
                                    </div>
                                  </div>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                          <div class="d_flex_start pt_5 pb_20">
                            <router-link
                              class="btn btn_transparent has_border_radius mr_10 d_flex_center"
                              :to="`/contact/${ticket.contact_id}/show`"
                            >
                              View All Activity
                            </router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>

                  <div class="accordion mb_0">
                    <div class="accordion_heading">
                      <div
                        class="accordion_heading_inner open"
                        data-toggle="collapse_slide"
                        data-target="#Card23"
                      >
                        <span
                          ><svg
                            fill="#000000"
                            width="15px"
                            height="15px"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 92 92"
                            enable-background="new 0 0 92 92"
                            xml:space="preserve"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <path
                                id="XMLID_1973_"
                                d="M25,17.8V5c0-2.8,2.2-5,5-5s5,2.2,5,5v12.8c0,2.8-2.2,5-5,5S25,20.6,25,17.8z M62,22.8c2.8,0,5-2.2,5-5V5 c0-2.8-2.2-5-5-5s-5,2.2-5,5v12.8C57,20.6,59.2,22.8,62,22.8z M28.2,40h35.5c2.2,0,4-1.8,4-4s-1.8-4-4-4H28.2c-2.2,0-4,1.8-4,4 S26,40,28.2,40z M84,7h-8.3c-2.2,0-4,1.8-4,4s1.8,4,4,4H80v68H12V15h4.3c2.2,0,4-1.8,4-4s-1.8-4-4-4H8c-2.2,0-4,2.2-4,4.4V87 c0,2.2,1.8,4,4,4h76c2.2,0,4-1.8,4-4V11.4C88,9.2,86.2,7,84,7z M42.7,15h6.6c2.2,0,4-1.8,4-4s-1.8-4-4-4h-6.6c-2.2,0-4,1.8-4,4 S40.5,15,42.7,15z M28.2,58h35.5c2.2,0,4-1.8,4-4s-1.8-4-4-4H28.2c-2.2,0-4,1.8-4,4S26,58,28.2,58z"
                              ></path>
                            </g></svg
                        ></span>
                        <span>TO-DO</span>
                      </div>
                    </div>
                    <div
                      class="accordion_body"
                      id="Card23"
                      style="display: block"
                    >
                      <todo-component
                        :todos="todos"
                        :type="'ticket'"
                        :fromId="'' + ticket.id"
                        @todo-added="addTodo"
                        @todo-updated="updateTodo"
                        @todo-deleted="deleteTodo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_menu">
      <h2>
        <span v-if="this.editableType == 'note'">Edit note</span>
        <span v-else>Edit email</span>
        <div
          class="close_right_menu cursor_pointer"
          @click.prevent="closeSidebar"
        >
          <span
            ><svg
              aria-hidden="true"
              focusable="false"
              role="presentation"
              class="icon icon-close"
              viewBox="0 0 64 64"
            >
              <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg
          ></span>
        </div>
      </h2>
      <div class="right_menu_content">
        <template v-if="this.editableType == 'note'">
          <div
            :class="['form_row', { has_error: errorFor('note_description') }]"
          >
            <label class="required">Description</label>
            <div class="form_inline">
              <text-editor
                v-model:text="note['note_description']"
                :id="'note_description'"
              ></text-editor>
              <v-errors :errors="errorFor('note_description')"></v-errors>
            </div>
          </div>
        </template>
        <template v-if="this.editableType == 'email'">
          <div :class="['form_row', { has_error: errorFor('subject') }]">
            <label class="required">Subject</label>
            <div class="form_inline">
              <input type="text" class="form_global" v-model="email.subject" />
              <v-errors :errors="errorFor('subject')"></v-errors>
            </div>
          </div>
          <div
            :class="['form_row', { has_error: errorFor('email_description') }]"
          >
            <label class="required">Description</label>
            <div class="form_inline">
              <text-editor
                v-model:text="email['email_description']"
                :id="'email_description'"
              ></text-editor>
              <v-errors :errors="errorFor('email_description')"></v-errors>
            </div>
          </div>
          <div :class="['form_row', { has_error: errorFor('contact_id') }]">
            <label class="required">Contact Email</label>
            <Multiselect
              v-model="selectedContact"
              :options="contacts"
              :multiple="false"
              :close-on-select="true"
              placeholder="Select a contact"
              label="name"
              :optionHeight="20"
              track-by="id"
              :custom-label="nameWithEmail"
              @Select="onContactSelect"
              @remove="onContactRemove"
            />
            <v-errors :errors="errorFor('contact_id')"></v-errors>
          </div>
          <div class="row">
            <div class="col_6">
              <div
                :class="['form_row', { has_error: errorFor('customer_name') }]"
              >
                <label>Contact name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="email.customer_name"
                  />
                  <v-errors :errors="errorFor('customer_name')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6">
              <div
                :class="['form_row', { has_error: errorFor('customer_phone') }]"
              >
                <label>Contact phone</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="email.customer_phone"
                  />
                  <v-errors :errors="errorFor('customer_phone')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6">
              <div :class="['form_row', { has_error: errorFor('company_id') }]">
                <label class="required"> Company</label>
                <Multiselect
                  v-model="email.company_id"
                  :options="companies"
                  :multiple="false"
                  :showLabels="false"
                  :close-on-select="true"
                  placeholder="Select a company"
                  :custom-label="emailCompanyLabel"
                  track-by="id"
                  :optionHeight="20"
                  @Select="onEmailCompanySelect"
                  @remove="onEmailCompanyRemove"
                />
                <v-errors :errors="errorFor('company_id')"></v-errors>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="bottom_btn">
        <button
          type="button"
          class="btn btn_transparent has_border_radius"
          @click.prevent="closeSidebar"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn_black has_border_radius ml_10 width_100p"
          v-if="this.editableType == 'note'"
          @click.prevent="updateNote"
          :disabled="isSubmitting"
        >
          Update
        </button>
        <button
          type="button"
          class="btn btn_black has_border_radius ml_10 width_100p"
          v-if="this.editableType == 'email'"
          @click.prevent="updateEmail"
          :disabled="isSubmitting"
        >
          Update
        </button>
      </div>
    </div>
    <ChatComponent v-if="ticket" :ticket="ticket" ref="chatComponentRef" />
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TodoComponent from '../../components/shared/TodoComponent.vue';
import Multiselect from 'vue-multiselect';
import ReplyBoxComponent from './ReplyBoxComponent';
import DatePicker from '@/components/shared/DatePicker';
import AttachmentPreviewComponent from './AttachmentPreviewComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import TicketActivityLogs from '@/components/shared/ticket/TicketActivityLogs.vue';
import ChatComponent from '@/components/shared/ticket/ChatComponent.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'ticket-view',
  components: {
    TicketActivityLogs,
    ChatComponent,
    LoaderMaskComponent,
    TodoComponent,
    Multiselect,
    DatePicker,
    ReplyBoxComponent,
    AttachmentPreviewComponent,
    TextEditor,
  },
  data() {
    return {
      lyLoading: false,
      ticket: null,
      activeTab: 'activityList',
      activities: [],
      tickets: [],
      todos: [],
      contacts: [],
      filter: {
        resolution_at: '',
        group_id: '',
        company_id: '',
        support_request_type_id: '',
        user_id: '',
        status: '',
        priority: '',
        contact_id: '',
        customer_name: '',
        customer_phone: '',
      },
      statuses: [
        {
          label: 'open',
          name: 'Open',
        },
        {
          label: 'pending',
          name: 'Pending',
        },
        {
          label: 'resolved',
          name: 'Resolved',
        },
        {
          label: 'closed',
          name: 'Closed',
        },
      ],
      priorities: [
        {
          label: 'low',
          name: 'Low',
        },
        {
          label: 'medium',
          name: 'Medium',
        },
        {
          label: 'high',
          name: 'High',
        },
        {
          label: 'urgent',
          name: 'Urgent',
        },
      ],
      groups: [],
      companies: [],
      requestTypes: [],
      users: [],
      showReplyBox: false,
      replyBoxType: '',
      note: {
        note_description: '',
      },
      email: {
        id: '',
        email_description: '',
        contact_id: '',
        subject: '',
        company_id: '',
        customer_email: '',
        customer_name: '',
        customer_phone: '',
      },
      selectedContact: null,
      isSubmitting: false,
      editableType: '',
      isShowTicketActivityLog: false,
      isHideCollapseContact: false,
      forwarded_message: '',
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
    // properties-panel contact; the ticket's customer_email is left untouched so replies still reach the original sender
    filterContact: {
      get() {
        if (!this.filter.contact_id) return null;
        return (
          this.contacts.find((c) => c.id == this.filter.contact_id) ||
          (this.ticket?.contact?.id == this.filter.contact_id
            ? this.ticket.contact
            : null)
        );
      },
      set(selected) {
        this.filter.contact_id = selected ? selected.id : '';
        this.filter.customer_name = selected ? selected.name : '';
        if (selected) {
          this.filter.customer_phone = selected.phone;
          if (selected.company_id) this.filter.company_id = selected.company_id;
        }
      },
    },
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.loadTicketData(this.$route.params.ticket_number);
      }
    },
  },
  created() {
    if (this.$route.params.ticket_number) {
      this.loadTicketData(this.$route.params.ticket_number);
    }
    this.getGroups();
    this.getRequestTypes();
    this.getUsers();
    this.getContacts();
    this.getCompanies();
  },
  mounted() {
    this.ticketDetailsScrollbar();
    if (this.$route.query.ref === 'from_notification') {
      this.fromNotificationTicket();
    }
  },
  methods: {
    userFirstLetter() {
      if (this.user?.name) {
        return this.user?.name.slice(0, 1);
      }
    },
    downloadFile(filePath) {
      const a = document.createElement('a');
      a.href = filePath;
      let filenameArr = filePath.split('/');
      let filename = filenameArr[filenameArr.length - 1];
      a.download = filename;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    hideShowCollapseContact() {
      this.isHideCollapseContact = !this.isHideCollapseContact;
    },
    nameWithEmail(data) {
      return `${data.name} — [ ${data.email} ]`;
    },
    onContactSelect(selected) {
      this.email.contact_id = selected.id;
      this.email.company_id = selected.company_id;
      this.email.customer_email = selected.email;
      this.email.customer_name = selected.name;
      this.email.customer_phone = selected.phone;
    },
    onContactRemove() {
      this.selectedContact = null;
      this.email.contact_id = '';
      this.email.company_id = '';
      this.email.customer_email = '';
      this.email.customer_name = '';
      this.email.customer_phone = '';
    },
    getGroups() {
      this.axios.get('/active-groups-for-relation').then(({ data }) => {
        this.groups = data.data;
      });
    },
    getCompanies() {
      this.axios.get('/active-companies-for-relation').then(({ data }) => {
        this.companies = data.data;
      });
    },
    getRequestTypes() {
      this.axios.get('/active-support-request-types').then(({ data }) => {
        this.requestTypes = data.data;
      });
    },
    getUsers() {
      this.axios.get('/active-users-for-relation').then(({ data }) => {
        this.users = data.data;
      });
    },
    getContacts() {
      this.axios.get('/active-contacts-for-relation').then(({ data }) => {
        this.contacts = data.data;
      });
    },
    loadTicketData(ticketNumber) {
      this.lyLoading = true;
      this.axios
        .get('/tickets/' + ticketNumber)
        .then((response) => {
          this.ticket = response.data.data;
          this.todos = this.ticket.todos;
          this.filter.resolution_at = this.ticket.resolution_at;
          this.filter.group_id = this.ticket.group_id;
          this.filter.company_id = this.ticket.company_id;
          this.filter.support_request_type_id =
            this.ticket.support_request_type_id;
          this.filter.user_id = this.ticket.user_id;
          this.filter.status = this.ticket.status;
          this.filter.priority = this.ticket.priority;
          this.filter.users = this.ticket.users;
          this.filter.contact_id = this.ticket.contact_id;
          this.filter.customer_name = this.ticket.customer_name;
          this.filter.customer_phone = this.ticket.customer_phone;

          if (this.$route.query.ref === 'from_notification') {
            setTimeout(() => {
              this.$refs.chatComponentRef.openChatBot();
            }, 200);
          }
        })
        .catch(() => {
          this.showFailMsg('No ticket exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    getEmailType(type, note_mode) {
      var statusText = '';
      var noteMode = '';
      if (note_mode && note_mode == 'private') {
        noteMode = 'Private';
      }
      if (note_mode && note_mode == 'public') {
        noteMode = 'Public';
      }
      switch (type) {
        case 'reply':
          statusText = 'Replied';
          break;
        case 'forward':
          statusText = 'Forwarded';
          break;
        case 'note':
          statusText = noteMode + ' Note';
          break;

        default:
          break;
      }
      return statusText;
    },
    deleteRecord(ticketId) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/tickets/' + ticketId).then(() => {
            this.$swal.fire('Deleted', 'Ticket has been deleted!', 'success');
            this.$router.replace({
              name: 'tickets',
            });
          });
        }
      });
    },
    changeTicketStatus(status) {
      this.$swal({
        title: 'Are you sure want to update status?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post('/ticket/status/' + this.ticket.id, { status: status })
            .then(() => {
              this.loadTicketData(this.ticket.ticket_number);
              this.showSuccessMsg('Updated Successfully!');
            });
        }
      });
    },
    addTodo(newTodo) {
      this.todos.unshift(newTodo);
    },
    updateTodo(updatedTodo) {
      const index = this.todos.findIndex((todo) => todo.id === updatedTodo.id);
      if (index !== -1) {
        this.todos.splice(index, 1, updatedTodo);
      }
    },
    deleteTodo(todoId) {
      this.todos = this.todos.filter((todo) => todo.id !== todoId);
    },
    groupLabel(option) {
      const group = this.groups.find((group) => group.id === option);
      return group ? group.name : option.name;
    },
    companyLabel(option) {
      const company = this.companies.find((company) => company.id === option);
      return company ? company.company_name : option.company_name;
    },
    emailCompanyLabel(option) {
      const company = this.companies.find((company) => company.id === option);
      return company ? company.company_name : option.company_name;
    },
    requestTypeLabel(option) {
      const requestType = this.requestTypes.find(
        (requestType) => requestType.id === option
      );
      return requestType ? requestType.name : option.name;
    },
    userLabel(option) {
      const user = this.users.find((user) => user.id === option);
      return user ? user.name : option.name;
    },
    statusLabel(option) {
      const status = this.statuses.find((status) => status.label === option);
      return status ? status.name : option.name;
    },
    priorityLabel(option) {
      const priority = this.priorities.find(
        (priority) => priority.label === option
      );
      return priority ? priority.name : option.name;
    },
    onGroupSelect(selected) {
      this.filter.group_id = selected.id;
    },
    onGroupRemove() {
      this.filter.group_id = '';
    },
    onCompanySelect(selected) {
      this.filter.company_id = selected.id;
    },
    onCompanyRemove() {
      this.filter.company_id = '';
    },
    onEmailCompanySelect(selected) {
      this.email.company_id = selected.id;
    },
    onEmailCompanyRemove() {
      this.email.company_id = '';
    },
    onRequestTypeSelect(selected) {
      this.filter.support_request_type_id = selected.id;
    },
    onRequestTypeRemove() {
      this.filter.support_request_type_id = '';
    },
    onUserSelect(selected) {
      this.filter.user_id = selected.id;
    },
    onUserRemove() {
      this.filter.user_id = '';
    },
    onStatusSelect(selected) {
      this.filter.status = selected.label;
    },
    onStatusRemove() {
      this.filter.status = '';
    },
    onPrioritySelect(selected) {
      this.filter.priority = selected.label;
    },
    onPriorityRemove() {
      this.filter.priority = '';
    },
    updateTicketDetails() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();
      formData.append('_method', 'PATCH');

      let userIds = this.filter.users?.map((user) => user.id);

      Object.keys(this.filter).forEach((key) => {
        formData.append(key, this.filter[key] ? this.filter[key] : '');
      });

      formData.delete('users');
      formData.append('user_ids', userIds);

      this.axios
        .post('/tickets/' + this.ticket.id, formData)
        .then(() => {
          this.loadTicketData(this.ticket.ticket_number);
          this.ticketDetailsScrollbar();
          this.showSuccessMsg('Ticket updated Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    openReplyBox(type, textMsg = null) {
      this.replyBoxType = type;
      this.showReplyBox = true;
      this.forwarded_message = textMsg;

      const box = this.$refs.targetSection;
      if (this.showReplyBox && box) {
        box.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
          let scrollHeight = box.scrollHeight + 600;
          box.scrollTo({
            top: scrollHeight,
            behavior: 'smooth',
          });
        }, 500);
      }
    },
    closeReplyBox(status) {
      this.replyBoxType = '';
      this.showReplyBox = false;
      if (status == 'success') {
        this.loadTicketData(this.ticket.ticket_number);
      }
    },
    openSidebar(data, type) {
      this.editableType = type;
      if (type == 'note') {
        this.note.id = data.id;
        this.note.note_description = data.description;
      }

      if (type == 'email') {
        this.email.id = data?.id;
        this.email.subject = data?.subject;
        this.email.email_description = data?.description;
        this.email.contact_id = this.ticket.contact_id;
        this.email.company_id = this.ticket.company_id;
        this.email.customer_name = this.ticket.customer_name;
        this.email.customer_email = this.ticket.customer_email;
        this.email.customer_phone = this.ticket.customer_phone;
        var contact = this.contacts.filter(
          (contact) => contact.id == this.ticket.contact_id
        );
        if (contact && contact.length > 0) {
          this.selectedContact = contact[0];
        }
      }

      document.body.classList.add('right_menu_open');
    },
    closeSidebar() {
      this.allErrors = null;
      this.note.id = '';
      this.note.note_description = '';
      this.email.id = '';
      this.email.subject = '';
      this.email.email_description = '';
      this.selectedContact = null;
      this.email.contact_id = '';
      this.email.company_id = '';
      this.email.customer_name = '';
      this.email.customer_email = '';
      this.email.customer_phone = '';
      this.editableType = '';
      document.body.classList.remove('right_menu_open');
    },
    updateNote() {
      this.allErrors = null;
      this.isSubmitting = true;

      this.axios
        .post('/update-note', this.note)
        .then(() => {
          this.loadTicketData(this.ticket.ticket_number);
          this.showSuccessMsg('Updated Successfully!');
          this.closeSidebar();
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    updateEmail() {
      this.allErrors = null;
      this.isSubmitting = true;

      this.axios
        .post('/update-email', this.email)
        .then(() => {
          this.loadTicketData(this.ticket.ticket_number);
          this.showSuccessMsg('Updated Successfully!');
          this.closeSidebar();
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteNote(emailId) {
      this.$swal({
        title: 'Are you sure want to delete note?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.post('/delete-email/' + emailId).then(() => {
            this.showSuccessMsg('Deleted Successfully!');
            this.loadTicketData(this.ticket.ticket_number);
          });
        }
      });
    },
    showTicketActivity() {
      this.isShowTicketActivityLog = !this.isShowTicketActivityLog;
    },
    fromNotificationTicket() {
      this.axios
        .post(`/from-notification-for-chat/${this.ticket.id}`, {
          from: this.$route.query.ref,
          user_id: this.user.id,
        })
        .then(() => []);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped></style>
